import { SET_TOAST } from "./actionTypes.js";

export function setToast(notification) {
  return {
    type: SET_TOAST,
    payload: notification,
  };
}
